// ─── useMsaList ─────────────────────────────────────────────────────────────
// Loads active MSAs from msa_definitions and returns them as a sorted list
// of names. Replaces the static DEFAULT_MARKETS constants import in every
// place a "which market is this?" dropdown or list is rendered.
//
// Optional `extras` prop: any strings you want unioned in (e.g. the market
// currently saved on a deal that predates the MSA taxonomy). Duplicates
// are stripped; overall result is sorted alphabetically.

import { useEffect, useState } from "react";
import { supabase } from "../supabase";

export default function useMsaList(extras = []) {
  const [msas, setMsas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("msa_definitions")
        .select("name")
        .eq("active", true)
        .order("display_order")
        .order("name");
      if (cancelled) return;
      const set = new Set((data || []).map(r => r.name));
      for (const e of extras || []) if (e) set.add(String(e));
      setMsas([...set].sort());
      setLoading(false);
    })();
    return () => { cancelled = true; };
    // extras is expected to be stable-ish; if callers want reactivity they can pass a memoized array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { msas, loading };
}
